// Header
import './Header.css';

import logoBosoTokyoWebp from '../img/logo-boso-tokyo.webp';
import logoBosoTokyo from '../img/logo-boso-tokyo.png';
import logoOpenseaWebp from '../img/logo-opensea.webp';
import logoOpensea from '../img/logo-opensea.png';
import logoDiscordWebp from '../img/logo-discord.webp';
import logoDiscord from '../img/logo-discord.png';
import logoTwitterWebp from '../img/logo-twitter.webp';
import logoTwitter from '../img/logo-twitter.png';
import menuIconOpen from '../img/icons/menu-icon-open.svg';
import menuIconClose from '../img/icons/menu-icon-close.svg';

import { Link } from "react-router-dom";

import React, { useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';

// Hero
import ScrollItem from './ScrollItem';

import HeroLogoWebp from '../img/Hero-logo-pc.webp';
import HeroLogo from '../img/Hero-logo-pc.png';
import SubLeftWebp from '../img/sub_left.webp';
import SubLeft from '../img/sub_left.png';
import SubCenterWebp from '../img/sub_center.webp';
import SubCenter from '../img/sub_center.png';
import SubRightWebp from '../img/sub_right.webp';
import SubRight from '../img/sub_right.png';
import './Hero.css';
import './Glitch.css';
// import SalePopup from './SalePopup';
import RevItUpPopup from './RevItUpPopup';

export default function Hero() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const el = useRef(null);

    const displayScrollItem = (inView, entry) => {
        if (inView) {
            el.current.classList.remove('isShow');
            el.current.classList.remove('glitchPattern01');
        } else {
            el.current.classList.add('isShow');
            el.current.classList.add('glitchPattern01');
        }
    }

    function HeaderDisplay({ children }) {
        return (
            <InView as="div" onChange={(inView, entry) => displayScrollItem(inView, entry)}>
                {children}
            </InView>
        )
    }

    const Menu = () => {
        return (
            <div className="Header__menu">
                <div className="Header__logo glitchPatternInfinite05">
                    <Link to="/">
                        <picture>
                            <source type="image/webp" srcSet={logoBosoTokyoWebp} />
                            <img src={logoBosoTokyo} alt="BoSo TOKYO ロゴ" />
                        </picture>
                    </Link>
                </div>
                <div className="Header__rightContainer">
                    <nav className="Header__nav">
                        <ul>
                            <li><Link to="/gallery">Gallery</Link></li>
                            <li><Link to="/revving">Revving</Link></li>
                            <li><a href="#about">About</a></li>
                            <li><a href="#vision">Vision</a></li>
                            <li><a href="#zoku">Zoku</a></li>
                            <li><a href="#roadmap">RoadMap</a></li>
                            <li><a href="#member">The Clan</a></li>
                            <li><Link to="/rule" target="_blank">Rules</Link></li>
                        </ul>
                    </nav>
                    <div className="Header__icon">
                        <a href="https://opensea.io/collection/bosotokyo-official" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoOpenseaWebp} />
                                <img src={logoOpensea} alt="OpenSea link" />
                            </picture>
                        </a>
                    </div>
                    <div className="Header__icon glitchPatternInfinite03">
                        <a href="https://discord.gg/bosotokyo" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoDiscordWebp} />
                                <img src={logoDiscord} alt="Discord link" />
                            </picture>
                        </a>
                    </div>
                    <div className="Header__icon glitchPatternInfinite04">
                        <a href="https://twitter.com/BosoTokyo" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoTwitterWebp} />
                                <img src={logoTwitter} alt="Twitter link" />
                            </picture>
                        </a>
                    </div>

                    <div className="Header__menuBtn">
                        <button onClick={() => setIsModalOpen(!isModalOpen)}><img src={isModalOpen ? menuIconClose : menuIconOpen} alt="sp menu open" /></button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {/* Header */}


            {isModalOpen ? (
                <header className="Header open .Header--hero" id="HeaderLogo" ref={el}>
                    <Menu />
                    <div className="Header__Modal">
                        <Menu />
                        <nav className="Header__nav--sp">
                            <ul>
                                <li><Link to="/gallery">Gallery</Link></li>
                                <li><Link to="/revving">Revving</Link></li>
                                <li><a href="#about" onClick={() => setIsModalOpen(!isModalOpen)}>About</a></li>
                                <li><a href="#vision" onClick={() => setIsModalOpen(!isModalOpen)}>Vision</a></li>
                                <li><a href="#zoku" onClick={() => setIsModalOpen(!isModalOpen)}>Zoku</a></li>
                                <li><a href="#roadmap" onClick={() => setIsModalOpen(!isModalOpen)}>RoadMap</a></li>
                                <li><a href="#member" onClick={() => setIsModalOpen(!isModalOpen)}>The Clan</a></li>
                                <li><Link to="/rule" target="_blank">Rules</Link></li>
                            </ul>
                        </nav>
                    </div>
                </header>
            ) : (
                <header className="Header Header--hero" id="HeaderLogo" ref={el}>
                    <Menu />
                </header>
            )}


            {/* Hero */}
            <section className="Hero" id="hero" >
                {/*  glitch background  */}
                {/* <ScrollItem> */}
                <div div className="glitch" >
                    <div className="glitch__img img__03"></div>
                    <div className="glitch__img img__03"></div>
                    <div className="glitch__img img__03"></div>
                    <div className="glitch__img img__03"></div>
                    <div className="glitch__img img__03"></div>
                </div>
                {/* </ScrollItem> */}

                <HeaderDisplay>
                    <div className="Hero__logo" id="HeroLogo">
                        <ScrollItem>
                            <div className="glitchPatternInfinite03">
                                <picture>
                                    <source type="image/webp" srcSet={HeroLogoWebp} />
                                    <img src={HeroLogo} alt="BOSO TOKYO logo" />
                                </picture>
                            </div>
                        </ScrollItem>
                    </div>
                </HeaderDisplay>

                {/*  Hero sub  */}
                <div className="Hero__sub01">
                    <picture>
                        <source type="image/webp" srcSet={SubLeftWebp} />
                        <img src={SubLeft} alt="sub" />
                    </picture>
                </div>
                <ScrollItem>
                    <div className="Hero__sub02">
                        <picture>
                            <source type="image/webp" srcSet={SubCenterWebp} />
                            <img src={SubCenter} alt="sub" />
                        </picture>
                    </div>
                </ScrollItem>
                <div className="Hero__sub03">
                    <picture>
                        <source type="image/webp" srcSet={SubRightWebp} />
                        <img src={SubRight} alt="sub" />
                    </picture>
                </div>

                {/*  glitch character  */}
                {/* <ScrollItem> */}
                <div className="glitch Hero__character">
                    <div className="glitch__img img__04"></div>
                    <div className="glitch__img img__04"></div>
                    <div className="glitch__img img__04"></div>
                    <div className="glitch__img img__04"></div>
                    <div className="glitch__img img__04"></div>
                </div>
                {/* </ScrollItem>s */}

                {/*  shadow cover  */}
                <div className="Hero__shadowCover"></div>

                {/* SalePopup */}
                <div className="SalePopupContainer">
                    {/* <SalePopup title="Whitelist Verifier" link="/presale" linkText="CHECK" /> */}
                    {/* <SalePopup title="PreSale" link="/presale" date="8/6 3:00AM - 8:59PM (UTC)" linkText="BUY" /> */}
                    {/* <SalePopup title="PublicSale" link="/publicsale" date="8/7 3:00AM - (UTC)" linkText="BUY" /> */}
                    <RevItUpPopup></RevItUpPopup>
                </div>
            </section >
        </>
    )
}